<div class="header-class title">
    <h6>Lignes du bon de commande : {{ bcLineForm?bcLineForm.controls.length: ''}}</h6>
    <button type="button" mat-raised-button color="success" (click)="addBcRow()">
        <mat-icon>add_box</mat-icon>
        Ajouter une ligne BC
    </button>
</div>
<div class="mat-table">
    <div *ngIf="bcForm">
        <form [formGroup]="bcForm">
            <div class="table_principal">
                <table #table mat-table [dataSource]="matDataSourceBCLigne" formArrayName="bcLines">
                    <caption>Liste des Bcs lignes</caption>
                    <ng-container matColumnDef="libelle">
                        <th mat-header-cell *matHeaderCellDef> Désignation </th>
                        <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index" class="padding-0">
                            <div class="with-padding-left">
                                {{element.get('libelle').value}} 
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="qte">
                        <th mat-header-cell *matHeaderCellDef> Qte </th>
                        <td mat-cell *matCellDef="let element;let index = index" class="allign-right"> 
                            <div class="with-padding-right">
                                {{element.get('qte').value| number:'1.4-4' :'fr'}} 
                            </div> 
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="dLivraison">
                        <th mat-header-cell *matHeaderCellDef> Date livraison </th>
                        <td mat-cell *matCellDef="let element;let index = index" class="centrer">
                            {{element.get('dLivraison').value| date: 'dd/MM/yyyy'}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="pu">
                        <th mat-header-cell *matHeaderCellDef> PU </th>
                        <td mat-cell *matCellDef="let element;let index = index" class="allign-right">
                            <div class="with-padding-right">
                                {{element.get('pu').value | currency:'EUR':'symbol':'1.2-2':'fr'}}
                            </div>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="tva">
                        <th mat-header-cell *matHeaderCellDef> TVA </th>
                        <td mat-cell *matCellDef="let element;let index = index" class="centrer">
                            {{element.get('codeTva').value}}-{{element.get('libelleTva').value}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="naCode">
                        <th mat-header-cell *matHeaderCellDef> NA </th>
                        <td mat-cell *matCellDef="let element;let index = index"
                            [matTooltip]="element.get('libelleNa').value" class="centrer">
                            {{element.get('codeNa').value}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="ttc">
                        <th mat-header-cell *matHeaderCellDef class="element-disabled"> TTC </th>
                        <td mat-cell *matCellDef="let element;let index = index">
                            <div class="with-padding-right">
                                {{element.get('ttc').value | currency:'EUR':'symbol':'1.2-2':'fr'}} 
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="cg">
                        <th mat-header-cell *matHeaderCellDef> CG Charge </th>
                        <td mat-cell *matCellDef="let element;let index = index"
                            [matTooltip]="element.get('libelleCgCharge').value" class="centrer">
                            {{element.get('codeCgCharge').value}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="ca1">
                        <th mat-header-cell *matHeaderCellDef> CA1 </th>
                        <td mat-cell *matCellDef="let element;let index = index"
                            [matTooltip]="element.get('libelleCa1').value" class="centrer">
                            {{element.get('codeCa1').value}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="ca2">
                        <th mat-header-cell *matHeaderCellDef> CA2 </th>
                        <td mat-cell *matCellDef="let element;let index = index"
                            [matTooltip]="element.get('libelleCa2').value" class="centrer">
                            {{element.get('codeCa2').value}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="complement">
                        <th mat-header-cell *matHeaderCellDef> Complément </th>
                        <td mat-cell *matCellDef="let element;let index = index"
                            [matTooltip]="element.get('libelleComp').value" class="centrer">
                            {{element.get('codeComp').value }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="equipement">
                        <th mat-header-cell *matHeaderCellDef> Equipement </th>
                        <td mat-cell *matCellDef="let element;let index = index" class="centrer">
                            {{element.get('vehicule').value}} </td>
                    </ng-container>

                    <ng-container matColumnDef="codeAe">
                        <th mat-header-cell *matHeaderCellDef> Chantier </th>
                        <td mat-cell *matCellDef="let element;let index = index" class="centrer">
                            {{element.get('chantier').value}} </td>
                    </ng-container>

                    <ng-container matColumnDef="mntHt">
                        <th mat-header-cell *matHeaderCellDef> HT</th>
                        <td mat-cell *matCellDef="let element;let index = index" class="allign-right">
                            <div class="with-padding-right">
                                {{element.get('ht').value | currency:'EUR':'symbol':'1.2-2':'fr'}} 
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef class="element-disabled"></th>
                        <td mat-cell *matCellDef="let element;let i = index" class="centrer">
                            <span matTooltip="Dupliquer cette ligne">
                                <mat-icon (click)="$event.stopPropagation(); duplicateRow(element, i); " class="blue-icon">control_point_duplicate</mat-icon> 
                            </span>
                            <span matTooltip="Supprimer cette ligne">
                                <mat-icon (click)="$event.stopPropagation(); deleteRow(element, i);" class="red-icon">close</mat-icon>
                            </span>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumnsBC ;sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumnsBC; let i = index" (click)="openModal(i, row)"></tr>
                </table>
            </div>
        </form>
    </div>
</div>